"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContent = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const react_1 = require("react");
const components_1 = require("./components");
const Button_1 = require("../Button");
const Form_1 = require("../Form");
function ModalContent({ className, onMouseOut, onMouseOver, isOpen, hasHeader, hasFooter, closeButton, title, closeIcon: CloseIcon, handleClose, children, buttons, footer, }) {
    const scrollLockRef = (0, app_1.useScrollLock)(isOpen);
    const ref = (0, react_1.useRef)(null);
    return ((0, jsx_runtime_1.jsxs)(components_1.StyledModal, Object.assign({ ref: (r) => {
            scrollLockRef(r);
            ref.current = r;
        }, open: isOpen, className: className, onMouseDown: (ev) => ev.stopPropagation(), onMouseOver: () => onMouseOver === null || onMouseOver === void 0 ? void 0 : onMouseOver(), onMouseOut: () => onMouseOut === null || onMouseOut === void 0 ? void 0 : onMouseOut(), transition: { duration: 0.2, delay: 0.05, ease: 'easeInOut' }, variants: {
            hidden: { y: 50, opacity: 0, scale: 0.85 },
            hiddenPrerender: { y: 50, opacity: 0, scale: 0.85 },
            visible: { y: 0, opacity: 1, scale: 1 },
            exit: { opacity: 0, y: 50, scale: 0.95 },
        } }, { children: [hasHeader && ((0, jsx_runtime_1.jsxs)("header", { children: [(0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "h5" }, { children: title })), closeButton && ((0, jsx_runtime_1.jsx)(components_1.StyledIconWrapper, Object.assign({ onClick: handleClose }, { children: CloseIcon ? (0, jsx_runtime_1.jsx)(CloseIcon, {}) : (0, jsx_runtime_1.jsx)(svg_1.SvgCloseMenu, {}) })))] })), !!children && (0, jsx_runtime_1.jsx)("section", { children: children }), hasFooter && ((0, jsx_runtime_1.jsxs)("footer", { children: [buttons && ((0, jsx_runtime_1.jsx)(components_1.StyledButtons, { children: buttons.map((_a, i) => {
                            var { label, kind, type } = _a, props = __rest(_a, ["label", "kind", "type"]);
                            const ActionButton = type === 'submit' ? Form_1.Submit : Button_1.Button;
                            return ((0, jsx_runtime_1.jsx)(ActionButton, Object.assign({ kind: kind !== null && kind !== void 0 ? kind : (i === buttons.length - 1 ? 'primary' : 'secondary') }, props, { children: label }), label));
                        }) })), footer] }))] })));
}
exports.ModalContent = ModalContent;
